export default __webpack_public_path__ + "static/media/enrolled_hover.88777462.png";